// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/theme.css
// module id = 1282
// module chunks = 33